import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/js/bootstrap';
import LoadScript from 'vue-plugin-load-script';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import BlockUI from 'vue-blockui';
import VueAxios from 'vue-axios';
import Toasted from 'vue-toasted';
import Vuelidate from 'vuelidate';
import VueKatex from 'vue-katex';
import $ from 'jquery';
import App from './App.vue';
import router from './router';
import axios from './utils/axios';
import * as params from './env';

window.$ = $;

Vue.config.productionTip = false;
Vue.use(VueKatex);
Vue.use(Vuelidate);
Vue.use(BlockUI);
Vue.use(VueAxios, axios);
Vue.use(Toasted, { theme: 'outline', duration: 3000 });
Vue.use(BootstrapVue);
Vue.use(LoadScript);

Vue.mixin((() => {
  const store = Vue.observable({
    languageGlobal: 'ES',
    collapsedLeftSidebar: false,
  });

  return {
    data() {
      return {
        loading: false,
        blockuimsg: 'Cargando...',
        languages: ['ES', 'CT', 'EU'],
      };
    },
    computed: {
      languageGlobal: {
        get() {
          return store.languageGlobal;
        },
        set(val) {
          store.languageGlobal = val;
        },
      },
      collapsedLeftSidebar: {
        get() {
          return store.collapsedLeftSidebar;
        },
        set(val) {
          store.collapsedLeftSidebar = val;
        },
      },
    },
    methods: {
      /**
      * @method openResourceWithParam
      * @description Opens the resource directly
      */
      openResourceWithParam(contentname, contentid) {
        console.log(`Opening resource: ${contentname} with id ${contentid}`);
        const nameroute = `edit_${contentname}`;
        const routeData = this.$router.resolve({ name: nameroute, params: { id: contentid } });
        window.open(routeData.href, '_blank');
      },
      /**
      * @method checkUserPermisson
      * @description checks if user have permissons for a tasks
      */
      checkUserEdit() {
        const user = JSON.parse(localStorage.getItem(params.default.USER_STORAGE));
        if (user && user.tipo.toString().indexOf('V') < 0) {
          return true;
        }
        return false;
      },
      checkUserEditSecondary() {
        const user = JSON.parse(localStorage.getItem(params.default.USER_STORAGE));
        if (user && user.tipo.toString().indexOf('E2') >= 0) {
          return true;
        }
        return false;
      },
      checkUserAdmin() {
        const user = JSON.parse(localStorage.getItem(params.default.USER_STORAGE));
        if (user && user.tipo.toString().indexOf('A') >= 0) {
          return true;
        }
        return false;
      },
      checkUserViewer() {
        const user = JSON.parse(localStorage.getItem(params.default.USER_STORAGE));
        if (user && user.tipo.toString().indexOf('V') >= 0) {
          return true;
        }
        return false;
      },
      checkUserViewerSecondary() {
        const user = JSON.parse(localStorage.getItem(params.default.USER_STORAGE));
        if (user && user.tipo.toString().indexOf('V2') >= 0) {
          return true;
        }
        return false;
      },
      checkUserDeveloper() {
        const user = JSON.parse(localStorage.getItem(params.default.USER_STORAGE));
        if (user && user.tipo.toString().indexOf('D') >= 0) {
          return true;
        }
        return false;
      },
    },
  };
})());

new Vue({
  router,
  validations: {},
  render: h => h(App),
}).$mount('#app');
